import Big from 'big.js'

/**
 * Calculates the total number of items in the data
 * @param {Array} data - The array of data items
 * @returns {number} The count of items
 */
export const calculateQuantity = (data) => data.length

/**
 * Calculates the total weight (ct) of items in the data
 * @param {Array} data - The array of data items
 * @returns {number} The total weight
 */
export const calculateTotalWeight = (data) => {
    if (!data || data.length === 0) return 0
    return data.reduce((acc, item) => acc.plus(item.ct || 0), Big(0)).toNumber()
}

/**
 * Calculates the total dollar amount of items in the data
 * @param {Array} data - The array of data items
 * @returns {number} The total amount in dollars
 */
export const calculateTotalAmount = (data) => {
    if (!data || data.length === 0) return 0
    return data.reduce((acc, item) => acc.plus(item.total_dollar || 0), Big(0)).toNumber()
}

/**
 * Formats a number as USD currency
 * @param {number} amount - The numeric amount to format
 * @returns {string} The formatted currency string
 */
export const formatCurrency = (amount) => {
    return amount.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })
}

/**
 * Aggregates all totals for the inquiry section
 * @param {Array} data - The array of data items
 * @returns {Object} An object containing all calculated and formatted totals
 */
export const calculateSelectionTotals = (data) => {
    const totalAmount = calculateTotalAmount(data)
    return {
        quantity: calculateQuantity(data),
        totalWeight: calculateTotalWeight(data),
        totalAmount: totalAmount,
        formattedAmount: formatCurrency(totalAmount)
    }
}
